import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-14">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              精选文章
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              助眠 ASMR <strong className="text-primary-600">深度指南</strong>
            </h2>
          </div>
          <Link
            to="/category"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1 no-underline"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 助眠 ASMR`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/85 backdrop-blur-sm text-foreground-700 text-xs font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>

              <div className="p-5">
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}